import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ViewUiStateService {
  saveState(key: string, state: Record<string, unknown>): void {
    sessionStorage.setItem(this.storageKey(key), JSON.stringify(state));
  }

  loadState(key: string): Record<string, unknown> | null {
    try {
      const raw = sessionStorage.getItem(this.storageKey(key));
      if (!raw) return null;

      const parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object') return null;

      return parsed as Record<string, unknown>;
    } catch {
      return null;
    }
  }

  clearState(key: string): void {
    sessionStorage.removeItem(this.storageKey(key));
  }

  private storageKey(key: string): string {
    return `${key}_ui_state`;
  }
}
